import script from "./VideoDetailComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoDetailComponent.vue?vue&type=script&setup=true&lang=js"

import "./VideoDetailComponent.vue?vue&type=style&index=0&id=3bb6696c&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bb6696c"]])

export default __exports__